<template>
  <div class="cruise">
    <h2 class="cruise__title">做邮轮生意，就找上船吧</h2>
    <p class="cruise__desc">全心全意为合作伙伴服务</p>
    <div class="cruise__nav">
      <ul>
        <li class="cruise__nav__item" v-for="(nav, index) in navs" :key="index">
          <el-image lazy fit="contain" class="cruise__nav__item__icon" :src="nav.icon"></el-image>
          <h5 class="cruise__nav__item__title">{{nav.title}}</h5>
          <p class="cruise__nav__item__desc">{{nav.desc}}</p>
          <!-- <el-image fit="contain" class="cruise__nav__item__bg" :src="nav.icon_bg"></el-image> -->
          <img fit="contain" class="cruise__nav__item__bg" :src="nav.icon_bg"></img>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      navs: [
        {
          icon: require("@/assets/img/home/icon_cruise_head_1.png"),
          title: "品牌曝光",
          desc: "完善品牌形象，提升品牌影响力",
          icon_bg: require("@/assets/img/home/icon_cruise_bg_1.png"),
        },
        {
          icon: require("@/assets/img/home/icon_cruise_head_2.png"),
          title: "邮轮专区",
          desc: "汇集100+媒体，10000+行业资讯",
          icon_bg: require("@/assets/img/home/icon_cruise_bg_2.png"),
        },
        {
          icon: require("@/assets/img/home/icon_cruise_head_3.png"),
          title: "视频教学",
          desc: "打造产品人员一对一剖析讲解",
          icon_bg: require("@/assets/img/home/icon_cruise_bg_1.png"),
        },
        {
          icon: require("@/assets/img/home/icon_cruise_head_4.png"),
          title: "营销服务",
          desc: "内容赋能、数据驱动、智能营销",
          icon_bg: require("@/assets/img/home/icon_cruise_bg_2.png"),
        },
        {
          icon: require("@/assets/img/home/icon_cruise_head_5.png"),
          title: "资源丰富",
          desc: "丰富的高佣产品，价格库存透明",
          icon_bg: require("@/assets/img/home/icon_cruise_bg_4.png"),
        },
        {
          icon: require("@/assets/img/home/icon_cruise_head_6.png"),
          title: "定制服务",
          desc: "超过20年旅游从业人员及领队",
          icon_bg: require("@/assets/img/home/icon_cruise_bg_3.png"),
        },
        {
          icon: require("@/assets/img/home/icon_cruise_head_7.png"),
          title: "及时响应",
          desc: "7*24小时在线， 1分钟内回复",
          icon_bg: require("@/assets/img/home/icon_cruise_bg_4.png"),
        },
        {
          icon: require("@/assets/img/home/icon_cruise_head_8.png"),
          title: "实时返佣",
          desc: "净价交易，不押款，不回团后结算",
          icon_bg: require("@/assets/img/home/icon_cruise_bg_3.png"),
        },
      ],
    };
  },
};
</script>
<style lang="scss" scoped>

.cruise {
  position: relative;
  background-color: #fff;
  padding: 5px;
  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 188px;
    background: linear-gradient(180deg, #f1f3f5 0%, #ffffff 100%);
    opacity: 0.9;
  }
  &::after {
    content: "";
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 188px;
    background: linear-gradient(360deg, #f1f3f5 0%, #ffffff 100%);
    opacity: 0.69;
  }
  &__title {
    padding-top: 60px;
    margin-bottom: 6px;
    color: #212529;
    font-size: 40px;
    font-weight: 600;
    text-align: center;
    position: relative;
  }
  &__desc {
    color: #adb5bd;
    font-size: 22px;
    text-align: center;
    position: relative;
    margin-bottom: 90px;
  }
  &__nav {
    position: relative;
    width: 1160px;
    margin: 0 auto;
    margin-bottom: 4px;
    z-index: 1;
    ul {
      // width: 1330px;
    }
    &__item {
      width: 263px;
      height: 172px;
      display: inline-block;
      vertical-align: top;
      border-radius: 4px;
      text-align: center;
      margin-right: 36px;
      margin-bottom: 112px;
      position: relative;
      &__title {
        color: #212529;
        font-size: 32px;
        font-weight: 600;
        padding: 20px 0;
        position: relative;
        z-index: 1;
      }
      &__desc {
        position: relative;
        z-index: 1;
        color: #495057;
        font-size: 16px;
      }
      &__icon {
        width: 65px;
        height: 65px;
        margin-top: -36px;
      }
      &__bg {
        width: 70px;
        height: 80px;
        position: absolute;
        object-fit: contain;
      }
      &:nth-child(1),
      &:nth-child(3) {
        .cruise__nav__item__bg {
          top: 0;
          right: 0;
        }
      }
      &:nth-child(2),
      &:nth-child(4) {
        .cruise__nav__item__bg {
          left: 0;
          top: 0;
        }
      }
      &:nth-child(5),
      &:nth-child(7) {
        .cruise__nav__item__bg {
          bottom: 0;
          right: 0;
        }
      }
      &:nth-child(6),
      &:nth-child(8) {
        .cruise__nav__item__bg {
          left: 0;
          bottom: 0;
        }
      }
      &:nth-child(4),
      &:nth-child(8) {
        margin-right: 0;
      }
      &:nth-child(odd) {
        border-top: 2px solid #d2dbff;
        box-shadow: 0px 2px 20px 0px rgba(165, 181, 200, 0.43);
      }
      &:nth-child(even) {
        border-top: 2px solid #ffd8d0;
        box-shadow: 0px 2px 20px 0px rgba(200, 183, 165, 0.43);
      }
    }
  }
}

</style>